import { render, staticRenderFns } from "./ListOfPrescriptionPage.vue?vue&type=template&id=22e6688a&scoped=true&"
import script from "./ListOfPrescriptionPage.vue?vue&type=script&lang=js&"
export * from "./ListOfPrescriptionPage.vue?vue&type=script&lang=js&"
import style0 from "./ListOfPrescriptionPage.vue?vue&type=style&index=0&id=22e6688a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e6688a",
  null
  
)

export default component.exports